import $ from "jquery";
import axios from "@/vendors/axios";
import "magnific-popup/dist/jquery.magnific-popup";
const addthis = window.addthis;
const AlbumGeneral = {
    init: () => {
        const $albumGenerals = document.querySelectorAll(".album-general");
        if ($albumGenerals.length === 0)
            return;
        AlbumGeneral.loop($albumGenerals);
    },
    loop: (elements) => {
        const sectionAlbums = document.querySelectorAll(".section-albums");
        elements.forEach((element) => {
            element.addEventListener("click", (event) => {
                const { albumId, albumType, albumTitle } = element.dataset;
                AlbumGeneral.fetchPhotos(element, albumId, albumTitle, albumType);
                event.preventDefault();
            });
        });
        sectionAlbums.forEach((section) => {
            const btnBacks = section.querySelectorAll(".btn-back");
            btnBacks.forEach((btnBack) => {
                btnBack.addEventListener("click", () => {
                    const tabPane = btnBack.closest(".tab-pane");
                    const photoListing = tabPane.querySelector(".photo-listing");
                    const albumListing = tabPane.querySelector(".album-listing");
                    photoListing.classList.add("d-none");
                    albumListing.classList.remove("d-none");
                });
            });
        });
    },
    fetchPhotos: async (element, id, title, albumType) => {
        const albumListing = element
            .closest(".tab-pane")
            .querySelector(".album-listing");
        const photoListing = element
            .closest(".tab-pane")
            .querySelector(".photo-listing");
        const row = photoListing.querySelector(".row");
        const albumTitle = photoListing
            .querySelector(".album-header h4");
        const { data } = await axios(`/api/${albumType}/albums/${id}`);
        let dataExtras = JSON.parse(data.extras);
        let album_items = JSON.parse(dataExtras.album_items);
        albumTitle.innerText = title;
        row.innerHTML = `${AlbumGeneral.renderPhotos(album_items, data.updated_at)}`;
        photoListing.classList.remove("d-none");
        albumListing.classList.add("d-none");
        $(".photo-listing").magnificPopup({
            delegate: "a",
            type: "image",
            gallery: {
                enabled: true,
            },
            removalDelay: 300,
            mainClass: "mfp-fade mfp-album",
            image: {
                markup: '<div class="mfp-figure">' +
                    '<div class="mfp-close"></div>' +
                    '<div class="mfp-img"></div>' +
                    '<div class="mfp-bottom-bar">' +
                    '<div class="mfp-bottom-left">' +
                    '<div class="mfp-title"></div>' +
                    '<div class="mfp-counter"></div>' +
                    "</div>" +
                    '<div class="mfp-bottom-right">' +
                    "<span>Share to: </span>" +
                    '<div class="a2a_kit a2a_kit_size_32 a2a_default_style">' +
                    '<li><a class="a2a_button_facebook"><i class="icon-facebook"></i></a></li>' +
                    '<li><a class="a2a_button_twitter"><i class="icon-twitter"></i></a></li>' +
                    '<li><a class="a2a_button_linkedin"><i class="icon-linkedin"></i></a></li>' +
                    '</div>' +
                    "</div>" +
                    "</div>" +
                    "</div>", // Popup HTML markup. `.mfp-img` div will be replaced with img tag, `.mfp-close` by close button
            },
            closeMarkup: '<button title="%title%" type="button" class="mfp-close"><i class="icon-x"></i></button>',
            callbacks: {
                open: () => {
                    window.a2a.init_all();
                },
            },
        });
    },
    renderPhotos: (data, updatedAt) => {
        return `${data
            .map((item) => `<div class="col-6 col-md-4 col-xl-3">
        <a href="/${item.image}?ver=${new Date(updatedAt).getTime()}" class="card image-link" title="${item.caption}">
          <div class="card-thumbnail">
            <img src="/${item.image}?${new Date(updatedAt).getTime()}" 
              alt="${item.caption}" />
          </div>
          ${item.caption
            ? `<div class="card-content">
              <span>${item.caption}<i class="icon-chevron-right"></i></span>
            </div>`
            : ""}
        </a>
      </div>`)
            .join("")}`;
    },
};
export default AlbumGeneral;
